/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostSearchCondition
 */
export interface PostSearchCondition {
    /**
     * 検索キーワード
     * @type {string}
     * @memberof PostSearchCondition
     */
    keyword: string;
}

export function PostSearchConditionFromJSON(json: any): PostSearchCondition {
    return PostSearchConditionFromJSONTyped(json, false);
}

export function PostSearchConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostSearchCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'keyword': json['keyword'],
    };
}

export function PostSearchConditionToJSON(value?: PostSearchCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'keyword': value.keyword,
    };
}

